"use client";

import { useEffect, useRef, useState } from "react";
import { Mic } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const animFrameRef = useRef<number>(0);
  const {
    ref: lineRef,
    isVisible: lineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [buttonHovered, setButtonHovered] = useState(false);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    let width = 0;
    let height = 0;
    const resize = () => {
      width = canvas.width = canvas.offsetWidth;
      height = canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);
    type Trail = {
      x: number;
      y: number;
      vx: number;
      vy: number;
      length: number;
      opacity: number;
      hue: number;
      width: number;
      life: number;
      maxLife: number;
    };
    const trails: Trail[] = [];
    const spawnTrail = () => {
      const fromLeft = Math.random() > 0.5;
      const x = fromLeft ? -100 : width + 100;
      const y = Math.random() * height;
      const speed = 2 + Math.random() * 4;
      const vx = fromLeft ? speed : -speed;
      const vy = (Math.random() - 0.5) * 0.5;
      const maxLife = 120 + Math.random() * 80;
      trails.push({
        x,
        y,
        vx,
        vy,
        length: 80 + Math.random() * 160,
        opacity: 0.1 + Math.random() * 0.2,
        hue: 221,
        width: 0.5 + Math.random() * 1.0,
        life: 0,
        maxLife
      });
    };
    let frame = 0;
    const animate = () => {
      ctx.clearRect(0, 0, width, height);
      frame++;
      if (frame % 25 === 0 && trails.length < 15) {
        spawnTrail();
      }
      for (let i = trails.length - 1; i >= 0; i--) {
        const t = trails[i];
        t.x += t.vx;
        t.y += t.vy;
        t.life++;
        const lifeRatio = t.life / t.maxLife;
        const fade = lifeRatio < 0.2 ? lifeRatio / 0.2 : lifeRatio > 0.8 ? (1 - lifeRatio) / 0.2 : 1;
        const grad = ctx.createLinearGradient(t.x - t.vx * (t.length / Math.abs(t.vx)), t.y, t.x, t.y);
        grad.addColorStop(0, `hsla(${t.hue}, 83%, 45%, 0)`);
        grad.addColorStop(1, `hsla(${t.hue}, 83%, 45%, ${t.opacity * fade})`);
        ctx.beginPath();
        ctx.moveTo(t.x - t.vx * (t.length / Math.abs(t.vx)), t.y);
        ctx.lineTo(t.x, t.y);
        ctx.strokeStyle = grad;
        ctx.lineWidth = t.width;
        ctx.stroke();
        if (t.life >= t.maxLife) {
          trails.splice(i, 1);
        }
      }
      animFrameRef.current = requestAnimationFrame(animate);
    };
    const waitReady = () => {
      if (canvas.offsetWidth > 0 && canvas.offsetHeight > 0) {
        resize();
        animate();
      } else {
        setTimeout(waitReady, 50);
      }
    };
    waitReady();
    return () => {
      cancelAnimationFrame(animFrameRef.current);
      window.removeEventListener("resize", resize);
    };
  }, []);
  return;
}